import { Link } from "react-router-dom";

const NavigationLink = ({ item }) => {
  return (
    <Link
      to={item.route}
      className="text-muted-foreground transition-colors hover:text-foreground"
    >
      <div className="flex flex-row gap-x-1 items-center">{item.label}</div>
    </Link>
  );
};

export default NavigationLink;
